import React from "react";
import { observer } from "mobx-react-lite";
import Form from "react-bootstrap/Form";
import { Card } from "react-bootstrap";

export interface ExposureCardProps {
  label: string;
  amount?: string;
}

const ExposureCard = observer((props: ExposureCardProps) => {
  const { label, amount } = props;

  return (
    <Card className="p-4 shadow-card">
      <Form.Label className="mb-0 text-nowrap">{label}</Form.Label>
      <h3 className="text-success p-0 m-0 text-nowrap">{amount}</h3>
    </Card>
  );
});

export default ExposureCard;
